import React from 'react';

export const StagingBadge: React.FC = () => {
  if (import.meta.env.VITE_ENV !== 'staging') return null;

  return (
    <div
      data-test-id="staging-badge"
      className="hidden md:flex fixed bottom-4 left-4 z-50 items-center gap-2 rounded-full bg-amber-500 px-3 py-1.5 text-xs font-semibold text-white shadow-lg ring-1 ring-amber-600/50 pointer-events-none select-none"
    >
      <span className="h-2 w-2 rounded-full bg-white animate-pulse" />
      This is staging environment
    </div>
  );
};
